import { z } from 'zod'
import { AlertLevelEnum } from './TAlertLevel'

export const AlertRuleTypeEnum = z.enum(['Standard', 'DeviceStatus'])
export type TAlertRuleType = z.infer<typeof AlertRuleTypeEnum>

export const createAlertRuleSchema = z
  .object({
    level: AlertLevelEnum.optional(),
    name: z.string().nonempty(),
    sendSms: z.boolean().default(false),
    sendEmail: z.boolean().default(false),
    smsNotificationIntervalMinutes: z.number().min(1).nullable().optional(),
    emailNotificationIntervalMinutes: z.number().min(1).nullable().optional(),
    smsFrequencyType: z.enum(['once', 'interval']).optional(),
    emailFrequencyType: z.enum(['once', 'interval']).optional(),
    alertRuleType: AlertRuleTypeEnum.default('Standard'),
    silenceThresholdMinutes: z.number().int().min(1).nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.alertRuleType === 'DeviceStatus' &&
      (data.silenceThresholdMinutes === null ||
        data.silenceThresholdMinutes === undefined)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'required',
        path: ['silenceThresholdMinutes'],
      })
    }
  })

export type TCreateAlertRuleFields = z.infer<typeof createAlertRuleSchema>

export const createAlertRuleResponse = z.object({
  alertRuleId: z.string(),
})

export type TCreateAlertRuleResponse = z.infer<typeof createAlertRuleResponse>
